<template>
    <div id="datatable-matrix-backoffice">
        <v-data-table
            :headers="headers"
            :items="listMatrix.filter((o) => o.isActive)"
            :hide-default-footer="true"
            dense
            class="table-striped"
        >
            <template v-slot:[`item.promoEngineCampaignTypeId`]="{ item }">
                <v-select
                    v-if="campaignTypes.length > 0"
                    :items="
                        campaignTypes.map((el) => ({
                            text: el.name,
                            value: +el.value,
                        }))
                    "
                    v-model="item.promoEngineCampaignTypeId"
                    :menu-props="{ top: false, offsetY: true }"
                >
                </v-select>
            </template>
            <template v-slot:[`item.promoEngineReceiverTypeId`]="{ item }">
                <v-select
                    v-if="receiverTypes.length > 0"
                    :items="
                        receiverTypes.map((el) => ({
                            text: el.name,
                            value: +el.value,
                        }))
                    "
                    v-model="item.promoEngineReceiverTypeId"
                    :menu-props="{ top: false, offsetY: true }"
                >
                </v-select>
            </template>
            <template v-slot:[`item.viewPermission`]="{ item }">
                <v-checkbox v-model="item.viewPermission" />
            </template>
            <template v-slot:[`item.downloadPermission`]="{ item }">
                <v-checkbox v-model="item.downloadPermission" />
            </template>
            <template v-slot:[`item.modifyPermission`]="{ item }">
                <v-checkbox v-model="item.modifyPermission" />
            </template>
            <template v-slot:[`item.forwardPermission`]="{ item }">
                <v-checkbox v-model="item.forwardPermission" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="div-actions">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                @click="$emit('on-delete-matrix-line', item)"
                                style="cursor: pointer"
                                class="mr-2 p-0"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <img
                                    src="/images/_SVGs/bo/remove.svg"
                                    :alt="$t('delete')"
                                    onload="SVGInject(this)"
                                    width="30"
                                    height="30"
                                    class="circle"
                                />
                            </span>
                        </template>
                        <span>{{ $t("delete") }}</span>
                    </v-tooltip>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        listMatrix: Array | Object,
        campaignTypes: Array | Object,
        receiverTypes: Array | Object,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t(
                        "backoffice.modules.promo-engine.campaign-type"
                    ),
                    align: "start",
                    value: "promoEngineCampaignTypeId",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t(
                        "backoffice.modules.promo-engine.receiver-type"
                    ),
                    align: "start",
                    value: "promoEngineReceiverTypeId",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.visualize"),
                    align: "start",
                    value: "viewPermission",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.download"),
                    align: "start",
                    value: "downloadPermission",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.modify"),
                    align: "start",
                    value: "modifyPermission",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.forward"),
                    align: "start",
                    value: "forwardPermission",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: "",
                    align: "start",
                    value: "actions",
                    width: "5%",
                    class: "header-table-color",
                    sortable: false,
                },
            ],
        };
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-matrix-backoffice {
    tr {
        height: 42px;
    }
}
</style>
